import { ProductStates } from '../../../../..';
import { onSearchResultsShown } from '../../../../../../common/analytics';
import { ResultsShownActionSubjectId } from '../../../../../../common/analytics/events';
import { type SearchItems } from '../../../result-types';
import { type CommonAttributes } from './product-state-analytics-types';
import { transformResults } from './utils';

export const postQueryAnalyticsGenerator = (
	productState: ProductStates,
	commonAttributes: CommonAttributes,
	previousState: ProductStates,
	postQueryItems: SearchItems,
) => {
	const results = transformResults(postQueryItems);
	if (previousState !== ProductStates.PostQueryLoading) {
		if (
			(previousState === ProductStates.PreQuerySuccess ||
				previousState === ProductStates.PostQuerySuccess) &&
			productState === ProductStates.PostQueryLoading &&
			results.length !== 0
		) {
			return onSearchResultsShown({
				actionSubjectId: ResultsShownActionSubjectId.CACHED,
				resultCount: postQueryItems.size || 0,
				sectionCount: postQueryItems.sections.length,
				results,
				...commonAttributes,
			});
		}
		return;
	}
	switch (productState) {
		case ProductStates.PostQueryNoResult:
		case ProductStates.PostQuerySuccess || ProductStates.PostQueryNoResult:
			return onSearchResultsShown({
				actionSubjectId: ResultsShownActionSubjectId.POSTQUERY,
				resultCount: postQueryItems.size || 0,
				sectionCount: postQueryItems.sections.length,
				results,
				...commonAttributes,
			});
		default:
			break;
	}
};
